import PublicSiteFooter from "../PublicChrome/PublicSiteFooter";

/**
 * The landing mounts the shared public footer. The company line is not
 * rendered. Channels and legal availability live in the shared footer.
 */
export default function LandingFooter() {
  return <PublicSiteFooter />;
}
